// core
import React from "react";
import Tippy from "@tippyjs/react";

// components
import Icon, { IconSizes } from "../Icon/Icon";

// styles
import cx from "classnames";
import styles from "./Tooltip.module.scss";

interface ITooltipProps {
    tooltipContent: React.ReactNode;
    className?: string;
    size?: IconSizes;
    placement?: any;
}

const Tooltip: React.FC<ITooltipProps> = (props) => {
    const { tooltipContent, className, children, placement } = props;
    const size = props.size ?? "l";

    return (
        <Tippy
            placement={placement || "bottom"}
            arrow
            trigger="mouseenter click"
            content={tooltipContent}>
            <button
                role="tooltip"
                type="button"
                aria-label={"Content: " + tooltipContent.toString()}
                aria-expanded="false"
                className={cx([styles["help-tooltip"], "btn-content-only", "layout-flex-row--centered"], {
                    [className]: !!className
                })}>
                <Icon
                    alt="Help"
                    size={size}
                    id="Help"
                    className={cx({ "space-m": !!children })}
                />
                {children}
            </button>
        </Tippy>
    );
};

export default Tooltip;
